import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import layouts from '@/layouts/index.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: layouts,
    children: [{ path: '/', name: 'home-index', component: () => import('../views/Home/index.vue') },],
  },

  {
    path: '/login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login/index.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  next();
});

export default router;
